import React from 'react'
import Screen from 'containers/Screen'
import RenovacaoBox from 'components/RenovacaoAntecipada2026/RenovacaoAntecipada2026'

export default function RenovacaoAntecipada2026Screen () {
  return (
    <Screen title={''}>
      <RenovacaoBox />
    </Screen>
  )
}
